/* eslint-disable react-intl/string-is-marked-for-translation, react/display-name */
/* global $ */
import { createElement } from 'rlink-react';
import Redirect from 'rlink-router/Redirect';
import { HASH } from 'rlink-router/constants';

import Main from 'components/Main';
import HomePageSplash from 'components/SplashScreen/HomePageSplash';
import FranchisePanels from 'components/Franchises/FranchisePanels';
import AboutUsPanel from 'components/AboutUs/AboutUsPanel';
import HistoryPanel from 'components/History/HistoryPanel';
import CareersPanel from 'components/Careers/connected/CareersPanel';
import HeaderNav from 'components/HeaderNav';
import Footer from 'components/Footer';
import ArticleModal from 'components/News/ArticleModal';
import CandidateNotice from 'components/Careers/CandidateNotice';

import AboutUsTheme from 'theme/AboutUs/components/AboutUsPanel.less';
import HistoryTheme from 'theme/History/components/HistoryPanel.less';
import CandidateNoticeTheme from 'theme/Careers/components/CandidateNotice.less';
import CareersPanelTheme from 'theme/Careers/components/CareersPanel.less';
import ArticleModalTheme from 'theme/News/components/ArticleModal.less';

export default function (params, content) {
  if (params[HASH] && params[HASH].includes('#news/')) {
    let [_, slug] = params[HASH].split('/');
    if (slug) {
      params.slug = slug;
      params[HASH] = '';
      return <Redirect view="home" params={params} />;
    }
  }
  if (!params.slug && typeof document !== 'undefined') {
    document.documentElement.className = '';
  }
  const articleSummaries = content.articleSummaries.data ? content.articleSummaries.data.get('items').toJS() : [];
  return (
    <Main title="Relic Entertainment | Game with us.">
      <div className="load">
        <div>
          <div className="spinner">
            <div className="spinner-container container1">
              <div className="circle1" />
              <div className="circle2" />
              <div className="circle3" />
              <div className="circle4" />
            </div>
            <div className="spinner-container container2">
              <div className="circle1" />
              <div className="circle2" />
              <div className="circle3" />
              <div className="circle4" />
            </div>
            <div className="spinner-container container3">
              <div className="circle1" />
              <div className="circle2" />
              <div className="circle3" />
              <div className="circle4" />
            </div>
          </div>
        </div>
      </div>
      <div id="master">
        <div role="document" className="page">
          <header id="header" role="banner" className="l-header clearfix">
            <HeaderNav />
            <HomePageSplash enableVideo={false} />
            <section className="l-header-region row" />
          </header>
          <main role="main" className="row l-main">
            <div className=" main column">
              <a id="main-content" />
              <div className="view view-home-page view-id-home_page view-display-id-page view-dom-id-949c65d272f4d1bb4d62343f6630f62a">
                <FranchisePanels franchiseData={content.franchises.data.get('items').toJS()} />
                <AboutUsPanel
                  studioCopy={content.homePage.data ? content.homePage.data.get('studioCopy') : ''}
                  studioSliderData={content.studioSlides.data.get('items').toJS()}
                  profileSliderData={content.profiles.data.get('items').toJS()}
                  cityGalleryImagesData={content.cityGalleryImages.data ? content.cityGalleryImages.data.get('items').toJS() : []}
                  theme={AboutUsTheme} />
                <HistoryPanel
                  historyData={content.historySlides.data.get('items').toJS()}
                  theme={HistoryTheme} />
                <CareersPanel careersCopy={content.homePage.data ? content.homePage.data.get('careersCopy') : ''} theme={CareersPanelTheme} />
              </div>
            </div>
          </main>
          <div className="layout-standard">
            <hr className="wrapper" />
          </div>
          <Footer />
          {params.slug && content.article.data
            && (
              <div className="ajax-node" style={{ display: 'none' }}>
                <ArticleModal
                  theme={ArticleModalTheme}
                  articleSummaries={articleSummaries}
                  article={content.article.data.toJS()} />
              </div>
            )
          }
          {params.slug === 'candidate-notice' && !content.article.data
            && (
              <div className="ajax-node" style={{ display: 'none' }}>
                <CandidateNotice theme={CandidateNoticeTheme} />
              </div>
            )
          }
        </div>
      </div>
    </Main>
  );
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/views/home.jsx